<template>
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-header">
        <div class="new-input">
          <span class="miv">N</span>
          <input type="text" placeholder="Търсене" v-model="searchUsers" />
        </div>
        <span class="miv modal-close" @click="close()">F</span>
      </div>
      <div class="modal-content">
        <div
          class="modal-content-check"
          :class="{ 'modal-content-check-disabled': user.isDisabled }"
          v-for="user in filteredUsers"
          :key="`addUsersModal-${user._id}`"
          :title="user.isDisabled ? 'Служителят е в отпуск.' : ''"
        >
          <label class="checkbox-wrapper">
            {{user.name}}
            <input
              type="checkbox"
              :id="user._id"
              v-model="user.isSelected"
              :disabled="user.isDisabled"
              @change="isCommingFromReport ? user.useIncomingWage ? user.useIncomingWage = false : null : null"
            />
            <span class="checkmark"></span>
          </label>
        </div>
        <!-- NO RESULTS -->
        <p class="modal-content-no-results" v-if="users.length && !filteredUsers.length">
          Няма намерени резултати за '
          <strong>{{this.searchUsers}}</strong>'
        </p>
      </div>
      <div class="modal-footer">
        <div class="select-btns">
          <button class="btn btn-select" @click="toggleUsers(true)">
            <span class="miv">W</span>
            Всички
          </button>
          <button class="btn btn-select" @click="toggleUsers(false)">
            <span class="miv">X</span>
            Никой
          </button>
        </div>
        <button class="btn btn-new" @click="save()">
          <span class="miv">Y</span>
          Запази
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['usersType', 'incomingUsers', 'date', 'isCommingFromReport'],
  data() {
    return {
      users: [],
      searchUsers: ''
    };
  },
  computed: {
    filteredUsers() {
      return this.filterUsers();
    }
  },
  methods: {
    getAllUsers() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/auth/users/${this.usersType}?active=true`)
        .then(response => {
          this.users = response.data;
          if (this.incomingUsers) {
            this.incomingUsers.forEach(iu => {
              this.users.forEach(u => {
                if (u._id === iu._id) {
                  u.isSelected = true;

                  if (iu.startHour) {
                    u.startHour = iu.startHour;
                  }
                  if (iu.startHourDate) {
                    u.startHourDate = iu.startHourDate;
                  }
                  if (iu.endHour) {
                    u.endHour = iu.endHour;
                  }
                  if (iu.endHourDate) {
                    u.endHourDate = iu.endHourDate;
                  }
                  if (iu.new) {
                    u.new = iu.new;
                  }
                  if (iu.elsewhereConfirmed) {
                    u.elsewhereConfirmed = iu.elsewhereConfirmed;
                  }

                  // when manualy change the isSelected state this should become false and his current wage should be assigned to the user
                  if (this.isCommingFromReport) {
                    u.useIncomingWage = true;
                    u.incomingWage = iu.wage;
                  }
                }
              });
            });
          }
          if (this.date) {
            this.getAbsentWorkers();
          }
        });
    },
    getAbsentWorkers() {
      this.$http
        .get(
          `${
            process.env.VUE_APP_BASE_URI
          }/otpusk/absent?date=${this.date.toISOString()}`
        )
        .then(response => {
          const absent = response.data;
          absent.forEach(a => {
            const i = this.users.map(u => u._id).indexOf(a.worker);
            this.users[i].isDisabled = true;
            this.$set(this.users, i, this.users[i]);
          });
        });
    },
    filterUsers() {
      return this.users.filter(u => {
        return u.name.toLowerCase().includes(this.searchUsers.toLowerCase());
      });
    },
    toggleUsers(toggle) {
      // If searching select only results
      if (this.searchUsers.length) {
        const tempFilteredUsers = this.filterUsers();
        this.users.forEach((u, index) => {
          tempFilteredUsers.forEach(fu => {
            if (fu._id === u._id) {
              if (!u.isDisabled) {
                let user = u;
                user.isSelected = toggle;
                if (this.isCommingFromReport) {
                  user.useIncomingWage ? (user.useIncomingWage = false) : null;
                }
                this.$set(this.users, index, user);
              }
            }
          });
        });
      }
      // Otherwise select/deselect all
      else {
        this.users.forEach((u, index) => {
          if (!u.isDisabled) {
            let user = u;
            user.isSelected = toggle;
            if (this.isCommingFromReport) {
              user.useIncomingWage ? (user.useIncomingWage = false) : null;
            }
            this.$set(this.users, index, user);
          }
        });
      }
    },
    getSelectedUsers() {
      return this.users.filter(u => {
        if (u.isSelected && u.useIncomingWage && this.isCommingFromReport) {
          u.wage = u.incomingWage;
        }
        return u.isSelected;
      });
    },
    close() {
      this.$parent.$emit('closeAddUsersModal');
    },
    save() {
      this.$parent.$emit('saveAddUsersModal', this.getSelectedUsers());
    }
  },
  mounted() {
    this.getAllUsers();
  }
};
</script>

<style scoped>
/* Responsive */
.modal-content-check-disabled {
  background-color: #f3eae6;
  opacity: 0.5;
}
@media screen and (max-width: 1000px) {
  .modal {
    max-height: 80vh;
    width: 90%;
  }
  .modal-header .new-input {
    width: 72%;
  }
}
@media screen and (max-width: 600px) {
  .modal-content-check {
    width: 45%;
  }
  .modal-footer {
    flex-direction: column;
    height: 97px;
  }
  .select-btns {
    margin: 10px 0;
  }
  .btn.btn-new {
    margin: 0 0 10px 0;
  }
}
@media screen and (max-width: 400px) {
  .modal-content-check {
    width: 100%;
  }
}
</style>
